/** @jsxImportSource @emotion/react */

import classNames from 'classnames';
import { switchUserTournament } from 'modules/auth/store/actions';
import AuthLayoutsMain from 'modules/auth/ui//layouts';
import { useAuthGuard } from 'modules/auth/ui/hooks/use-auth-guard';
import { useAvailableTournaments } from 'modules/auth/ui/hooks/use-available-tournaments';
import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import { scrollbar } from 'shared/styles/scrollbar';

import { AppDispatch } from 'store/store';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';
import UDButton from 'ud-ui/components/button';
import Pagination from 'ud-ui/components/pagination';
import UDSearchComponent from 'ud-ui/components/search/search-component';

const AuthPagesSelectTournament = () => {
  useAuthGuard();

  const dispatch = useDispatch<AppDispatch>();
  const { isLoading, data: availableTournaments, pages, currentPage, filter, changeFilter } = useAvailableTournaments();

  const handleTournamentSelected = useCallback(
    (tournamentId: number) => async () => {
      dispatch(switchUserTournament(tournamentId));
    },
    [dispatch],
  );

  const handleSearchKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (!availableTournaments) {
        return;
      }

      if (e.key === 'Enter') {
        e.preventDefault();
        if (availableTournaments.length > 0) {
          void handleTournamentSelected(availableTournaments[0].id)();
        }
      }
    },
    [availableTournaments, handleTournamentSelected],
  );

  // TODO: add error handling
  // useEffect(() => {
  //   if (isError) {
  //     toast.error('Произошла ошибка при получение турниров, перезагрузите страницу');
  //   }
  // }, [isError]);

  const body = useMemo(() => {
    // if (isError) {
    //   return (
    //     <UDText isNew={true} type="text-1" className="text-[#9093AA] mt-7.5 text-center">
    //       Произошла ошибка, попробуйте ещё раз
    //     </UDText>
    //   );
    // }

    if (isLoading) {
      return (
        <div className="flex-center h-[320px] w-full">
          <ClipLoader color="white" />
        </div>
      );
    }

    if (!availableTournaments?.length) {
      return (
        <UDText isNew={true} type="text-1" className="mt-7.5 text-center text-[#9093AA]">
          Организатора с таким названием нет.
        </UDText>
      );
    }

    return (
      <div css={scrollbar(theme)} className="min-h-0 flex-1 overflow-y-auto">
        {availableTournaments.map((tournament, index) => (
          <div className={classNames({ 'mt-2.5': index !== 0 })} key={tournament.id}>
            <UDButton className="w-full" variant="primary" type="button" onClick={handleTournamentSelected(tournament.id)}>
              {tournament.name}
            </UDButton>
          </div>
        ))}
        <div className="flex-center w-full">
          <Pagination
            pages={pages}
            currentPage={currentPage}
            onPageChange={(page) => changeFilter('page', page)}
            pagesShow={8}
            className="mt-7.5"
          />
        </div>
      </div>
    );
  }, [availableTournaments, changeFilter, currentPage, handleTournamentSelected, isLoading, pages]);

  return (
    <AuthLayoutsMain
      title=""
      subtitle=""
      contentClassName="overflow-hidden min-h-0"
      formContainerProps={{
        className: 'flex flex-col h-full min-h-0',
        style: {
          height: 522,
          justifyContent: 'flex-start',
        },
      }}
    >
      <div className="flex h-full min-h-0 flex-col">
        <UDText type="title-4" isNew={true} color="white" className="mb-5">
          Список организаторов
        </UDText>
        <UDSearchComponent
          autoFocus
          placeholder="Название организации"
          value={filter}
          onChange={(event) => changeFilter('filter', event.target.value)}
          onKeyDown={handleSearchKeyDown}
          className="mb-7.5"
        />
        {body}
      </div>
    </AuthLayoutsMain>
  );
};

export default AuthPagesSelectTournament;
